import Errors from './Errors';
import _ from 'lodash';
import axios from 'axios';
import {toFormData} from "./FormData";
class Form {
    /**
     * Initialize class
     *
     * @param {object} data
     * @param {mixed} form
     * @param {array} props
     */
    constructor(data, form = null, props = []) {
        this.initializeModel(data);
        this.form = form;

        if (!_.isNil(this.form)) {
            this.action = $(this.form).attr('action');
        }

        this.props = props;
        this.setClassVariables();

        this.errors = new Errors();

        this.files = false;
    }

    /**
     * Initialize the model data for the form.
     *
     * @param {object} data
     */
    initializeModel(data) {
        this.originalData = data;
        this.model = {};

        for (let field in data) {
            this.model[field] = data[field];
        }
    }

    /**
     * Initialize class variables.
     */
    setClassVariables() {
        this.showBlock = true;
        // Display generic ajax error message
        this.showErrorMessage = true;
        // Show error or success message on ajax requests
        this.showResponse = true;
    }

    /**
     * Enable the show block method.
     */
    enableShowBlock() {
        this.showBlock = true;
        return this; // Return 'this' for method chaining
    }

    /**
     * Disable the show block method.
     */
    disableShowBlock() {
        this.showBlock = false;
        return this; // Return 'this' for method chaining
    }

    /**
     * Enable error message.
     */
    enableErrorMessage() {
        this.showErrorMessage = true;
        return this;
    }

    /**
     * Disable error message.
     */
    disableErrorMessage() {
        this.showErrorMessage = false;
        return this;
    }

    /**
     * Enable show response.
     */
    enableShowResponse() {
        this.showResponse = true;
        return this;
    }

    /**
     * Disable show response.
     */
    disableShowResponse() {
        this.showResponse = false;
        return this;
    }

    /**
     * Reset the form.
     */
    reset() {
        for (let field in this.originalData) {
            this.originalData[field] = '';
        }

        this.errors.clear();
        return this;
    }

    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this.originalData[property];
        }

        return this.mergeAppends(data);
    }

    /**
     * Set appended data.
     *
     * @param {object} appends
     */
    setAppends(appends) {
        this.appends = appends;
        return this;
    }

    /**
     * Get relevant form data for request.
     */
    getFormData() {
        if (_.isEmpty(this.props)) {
            return this.data();
        }

        let data = {};

        _.forEach(this.props, (property) => {
            data[property] = _.defaultTo(this.originalData[property], null);
        });

        return this.mergeAppends(data);
    }

    /**
     * Merge form data with appended data.
     *
     * @param {object} data
     */
    mergeAppends(data) {
        if (!_.isNil(this.appends)) {
            data = _.merge(data, this.appends);
        }

        return data;
    }

    /**
     * Send files
     */
    asFile() {
        this.files = true;
        return this;
    }

    /**
     * Submit a post request.
     *
     * @param {string} url
     */
    post(url = '') {
        return this.submit('post', url);
    }

    /**
     * Submit an ajax request.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url = '') {
        let data = this.getFormData();

        if (this.showBlock && this.form) {
            showBlock(this.form);
        }

        if (! _.isNil(this.action)) {
            url = this.action;
        }

        this.errors.clear();

        if (this.files) {
            //let fd = new FormData();
            //for (let property in data) {
            //	if( _.isArray(data[property]) || _.isObject(data[property]) ){
            //        fd.append(property, JSON.stringify(data[property]));
            //	}else{
            //        fd.append(property, data[property]);
            //	}
            //}
            data = toFormData(data);
        }

        // Submit ajax request
        return new Promise((resolve, reject) => {
            axios[requestType](url, data)
                .then(({data}) => {
                    if (this.showBlock && !_.isNil(this.form)) {
                        removeBlock(this.form);
                    }

                    if (! _.isNil(data.error)) {
                        let type,
                            message;

                        if (data.error) {
                            if (data.errors) {
                                this.errors.record(data.errors);
                                resolve(data);
                                return;
                            }
                            type = 'error';
                            message = _.isNil(data.message) ? 'Request Unsuccessful' : data.message;
                        } else {
                            type = 'success';
                            message = _.isNil(data.message) ? 'Request Successful' : data.message;
                        }

                        if (this.showResponse && _.isFunction(showResponse)) {
                            showResponse(message, type);
                        }
                    }
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                    console.info(error);
                })
        });

        return;
    }
}

export default Form;